(function () {
  const initAnnouncementBar = (container) => {
    const sliders = container.querySelectorAll('.announcement-bar__swiper');

    sliders.forEach((slider) => {
      if (slider.swiper) return;
      if (slider.querySelectorAll('.swiper-slide').length < 2) return;

      new Swiper(slider, {
        slidesPerView: 1,
        loop: true,
        speed: 500,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        autoplay: {
          delay: Number(slider.dataset.interval) || 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }
      });
    });
  };

  initAnnouncementBar(document);

  document.addEventListener('shopify:section:load', (event) => {
    initAnnouncementBar(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const slider = event.target.closest('.announcement-bar__swiper');
    if (!slider || !slider.swiper) return;

    slider.swiper.autoplay.stop();
    slider.swiper.slideToLoop(Number(event.target.dataset.index));
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    const slider = event.target.closest('.announcement-bar__swiper');
    if (!slider || !slider.swiper) return;

    slider.swiper.autoplay.start();
  });
})();